module.exports = __webpack_public_path__ + "img/laptop_robo2.d2c1f789.svg";